module.exports = __webpack_public_path__ + "static/kelly-services-canada-logo-47859b3baf5b8cec0c6ea89074549a5e.png";